<template>
  <div class="sign-in-form">
    <div class="sign-in-form__content">
      <h2 class="sign-in-form__title">{{$tAuth('Partner registration')}}</h2>

      <div class="sign-in-form__top-text  text">
        <p>{{ $tAuth('text-for-partner') }}</p>
      </div>

      <div class="sign-in-form__group">
        <div class="sign-in-form__row">
          <div class="sign-in-form__col _col-2">
            <BaseInput :label="$tAuth('Your name')"
                       v-model="inputs.firstname.value"
                       :error="inputs.firstname.error"/>
          </div>
          <div class="sign-in-form__col _col-2">
            <BaseInput :label="$tAuth('Surname')"
                       v-model="inputs.lastname.value"
                       :error="inputs.lastname.error"/>
          </div>
          <div class="sign-in-form__col">
            <BaseInput label="E-mail"
                       v-model="inputs.email.value"
                       :error="inputs.email.error"/>
          </div>
          <div class="sign-in-form__col">
            <BaseInput :label="$tAuth('ITN')"
                       v-model="inputs.inn.value"
                       :error="inputs.inn.error"
                       mask="##########"/>
          </div>
          <div class="sign-in-form__col _col-2">
            <BaseInputPhone :label="$tAuth('Phone number')"
                            v-model="inputs.phone.value"
                            :error="$tAuth(inputs.phone.error)"
                            @input="onInput('phone')"
                            @validate="onValidateTel"
                            @keypress.enter.prevent.native="isPhoneSuccessButtonActive ? sendPhone() : null"/>
          </div>
          <div class="sign-in-form__col _col-2" style="align-self: flex-end">
            <button v-if="isPhoneSuccessButtonActive"
                    type="button"
                    @click.prevent="sendPhone"
                    :class="pendingSendPhone ? '_pending' : null"
                    class="base-btn base-btn--outline-dark sign-in-form__col-btn">
              <span v-if="isSent"
                    class="base-btn__text">{{$tAuth('Send again')}}</span>
              <span v-else
                    class="base-btn__text">{{$tAuth('Confirm')}}</span>
              <BasePreloader v-if="pendingSendPhone"/>
            </button>
            <button v-else
                    type="button"
                    disabled
                    :class="pendingSendPhone ? '_pending' : null"
                    class="base-btn base-btn--outline-dark sign-in-form__col-btn  _disabled">
              <SignInFormTimer v-if="showTimer"
                               :durationS="timerDurationS"
                               @end="onTimerEnd"
                               class="sign-in-form__phone-timer"/>
              <span v-else-if="isSent"
                    class="base-btn__text">{{$tAuth('Send again')}}</span>
              <span v-else
                    class="base-btn__text">{{$tAuth('Confirm')}}</span>
              <BasePreloader v-if="pendingSendPhone"/>
            </button>
          </div>
          <template v-if="isSent">
            <div v-if="message" class="sign-in-form__col  _col-full">
              <BaseAlert :value="message" class="sign-in-form__message  _message"/>
            </div>

            <div class="sign-in-form__col _col-2">
              <BaseInput :label="$tAuth('SMS code')"
                         v-model="inputs.code.value"
                         :error="$tAuth(inputs.code.error)"
                         name="sms-code"
                         onautocomplete="off"
                         @keypress.enter.prevent.native="isLoginButtonActive ? onLogin() : null"
                         type="password"
              />
            </div>
            <div class="sign-in-form__col _col-2" style="align-self: flex-end;">
              <button v-if="isLoginButtonActive"
                      type="button"
                      @click.prevent="onLogin"
                      :class="pendingLogin ? '_pending' : null"
                      class="base-btn base-btn--green sign-in-form__col-btn">
                <span class="base-btn__text">{{$tAuth('Sign in')}}</span>
                <BasePreloader v-if="pendingLogin"/>
              </button>
              <button v-else
                      type="button"
                      disabled
                      :class="pendingLogin ? '_pending' : null"
                      class="base-btn base-btn--green sign-in-form__col-btn  _disabled">
                <span class="base-btn__text">{{$tAuth('Sign in')}}</span>
                <BasePreloader v-if="pendingLogin"/>
              </button>
            </div>
          </template>
        </div>
      </div>

      <BaseCheckbox v-if="!isSent"
                    :checked="agree"
                    @input="onAgreeChange"
                    class="sign-in-form__checkbox"
      >
        <div slot="label"
             class="checkbox__text">
          {{$tAuth('I agree to the')}}
          <router-link-modified :to="{name:'terms-of-use'}"
                                target="_blank"
                                tag="a">
            {{$tAuth('terms of the user agreement')}}</router-link-modified>,
          <router-link-modified :to="{name:'privacy-policy'}"
                                target="_blank"
                                tag="a"

          >{{$tAuth('privacy policy')}}
          </router-link-modified>&nbsp;
          {{$tAuth('and')}}&nbsp;
          <router-link-modified :to="{path: formatPath('/partners-public-offer/')}"
                                target="_blank"
                                tag="a"
          >
            {{$tAuth('terms of the offer')}}
          </router-link-modified>
        </div>
      </BaseCheckbox>

      <BaseAlert :value="overallErrorsMix"
                 class="sign-in-form__alert  _error"/>

      <div class="sign-in-form__registered">
        <div class="sign-in-form__registered-label">{{$tAuth('Already registered?')}}</div>
        <router-link-modified :to="{name: 'auth'}"
                              tag="a"
                              class="sign-in-form__registered-btn base-btn base-btn--green">
          <span>{{$tAuth('Login to the site')}}</span>
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import SignInFormTimer from './SignInFormTimer'
  import authMixin from '../../mixins/authMixin'
  import {PARTNER} from "@/constants/usersTypes"

  export default {
    name: 'SignInFormPartner',
    mixins: [authMixin],
    components: {SignInFormTimer},
    data() {
      return {
        isPartner: true,
        inputs: {
          user_type: {
            value: PARTNER,
            error: null
          },
          phone: {
            value: null,
            error: null,
            required: true
          },
          code: {
            value: null,
            error: null
          },
          partner_referal_code: {
            value: null,
          },
          firstname: {
            value: null,
            required: true
          },
          lastname: {
            value: null,
            required: true
          },
          email: {
            value: null,
            required: true
          },
          inn: {
            value: null,
            required: true
          }
        },
      }
    },
    methods: {
      formatPath(path) {
        const locale  = this.$store.state.currentLocale

        if(locale === 'ua') {
          return  path
        }

        return '/' + locale + path
      }
    }
  }
</script>

<style>

</style>
